import { LayoutHeader } from "@/Header";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { ContractTabRequests } from "@/business/contract/ContractTabRequests";
import { ContractTabContracts } from "@/business/contract/ContractTabContracts";
import { ContractPinGate } from "@/business/contract/ContractPinGate";

/** 계약 현황 — 진행중(서명 대기) + 체결 완료 2탭 */
export const Route = createFileRoute("/business/layout/contract-status")({
  component: RouteComponent,
});

type Tab = "in-progress" | "completed";

function RouteComponent() {
  const [tab, setTab] = useState<Tab>("in-progress");

  return (
    <>
      <LayoutHeader title="계약 현황" hasBackBtn hasFootPrint={false} />
      <ContractPinGate>
        <div className="flex-1 min-h-0 flex flex-col bg-[#F5F5F5]">
          {/* 고정 영역 — 스크롤 안 됨 */}
          <div className="flex bg-white border-b border-[#E9E9E9] shrink-0">
            <TabButton
              active={tab === "in-progress"}
              label="진행중"
              onClick={() => setTab("in-progress")}
            />
            <TabButton
              active={tab === "completed"}
              label="체결 완료"
              onClick={() => setTab("completed")}
            />
          </div>
          {/* 스크롤 영역 */}
          <div className="flex-1 min-h-0 overflow-y-auto pt-2">
            {tab === "in-progress" && <ContractTabRequests />}
            {tab === "completed" && <ContractTabContracts />}
          </div>
        </div>
      </ContractPinGate>
    </>
  );
}

const TabButton = ({
  active,
  label,
  onClick,
}: {
  active: boolean;
  label: string;
  onClick: () => void;
}) => (
  <button
    type="button"
    onClick={onClick}
    className={`flex-1 py-3 text-[14px] font-semibold transition-colors ${
      active
        ? "text-[#FF9934] border-b-2 border-[#FF9934]"
        : "text-[#999] border-b-2 border-transparent"
    }`}
  >
    {label}
  </button>
);
